import {
  collection,
  getDocs,
  query,
  orderBy,
} from 'firebase/firestore';
import { db } from '../firebase/firestore';
import { createModel } from './model';
import orgs from './orgs';

export const schema = {
  name: 'user',
  collectionName: 'users',
  properties: {
    createdAt: {
      type: 'timestamp',
      label: 'Created At',
      required: true,
    },
    updatedAt: {
      type: 'timestamp',
      label: 'Updated At',
      required: true,
    },
    fcmToken: {
      type: 'string',
      label: 'FCM Token',
      required: true,
    },
    settings: {
      type: 'map',
      label: 'Settings',
      required: true,
    },
    // displayName: {
    //   type: 'string',
    //   label: 'Display Name',
    //   required: true,
    // },
    // photoURL: {
    //   type: 'string',
    //   label: 'Photo URL',
    //   required: true,
    // },
    // email: {
    //   type: 'string',
    //   label: 'Email',
    //   required: true,
    // },
  },
  inputProperties: [
    'displayName',
  ],
  getOptionLabel: user => user.displayName,
  getTitle: user => user.displayName,
};

const model = Object.assign(createModel(schema), {
  getOrgMemberships: async (userId) => {
    const querySnap = await getDocs(query(
      collection(db, 'users', userId, 'memberships'),
      orderBy('updatedAt', 'desc'),
    ));

    return Promise.all(querySnap.docs.map(async (docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
      org: await orgs.get(docSnap.id),
    })));
  },
});

export default model;
